import { render, staticRenderFns } from "./PosCashCounter.vue?vue&type=template&id=3a587471&scoped=true"
import script from "./PosCashCounter.vue?vue&type=script&lang=js"
export * from "./PosCashCounter.vue?vue&type=script&lang=js"
import style0 from "./PosCashCounter.vue?vue&type=style&index=0&id=3a587471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a587471",
  null
  
)

export default component.exports